import { Userpilot } from 'userpilot';

const appToken = '23bq86d10';

export function initializeUserpilot(): void {
  Userpilot.initialize(appToken);
}
